import React from "react";
import { FormBuilder, Form } from "@redriver/cinnamon";
import { Grid, Button } from "semantic-ui-react";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Pen from "features/../../../shared/assets/pen.svg";
import Save from "features/../../../shared/assets/save.svg";
import { AccordionContentPanel } from "components/displays";
import {
  getAssignmentLetterSettings,
  updateAssignmentLetterSettings,
} from "../../../actions";

const AssignmentLetterSettings = ({
  settingsId,
  collapsedOnLoad,
  expand,
  setExpand,
  contract,
}) => {
  return (
    <FormBuilder
      initialReadOnly
      loadAction={getAssignmentLetterSettings}
      loadParams={{ settingsId }}
      submitAction={updateAssignmentLetterSettings}
      submitParams={{ settingsId }}
      renderSubmitting={false}
      renderError={false}
      renderForm={(formProps, { readOnly }, events) => (
        <Form {...formProps}>
          <AccordionContentPanel
            title="Assignment Letter"
            wrapperCssClass="outline-grid"
            headerCssClass="defaults-page-title"
            collapsedOnLoad={collapsedOnLoad}
            expand={expand}
            contract={contract}
            headerContent={
              <PermissionCheck target={Targets.Defaults} action={Actions.Edit}>
                <div className="flex">
                  {!readOnly && (
                    <Button
                      primary
                      className="cancel-title-action"
                      floated="right"
                      content="Cancel"
                      onClick={events.onReset}
                    />
                  )}
                  <IconButton
                    primary
                    icon={readOnly ? Pen : Save}
                    content={readOnly ? "Edit" : "Save"}
                    floated="right"
                    onClick={() => {
                      readOnly
                        ? events.onToggleReadOnly()
                        : events.onSubmit({ reset: ["readOnly"] });
                      setExpand(!expand);
                    }}
                    className={!readOnly ? "positive-title-action" : null}
                  />
                </div>
              </PermissionCheck>
            }
          >
            <div className="padded">
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Form.Checkbox
                      label="Assignment Letter Required"
                      field="assignmentLetterRequired"
                      disabled={readOnly}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </AccordionContentPanel>
        </Form>
      )}
    />
  );
};

export default AssignmentLetterSettings;
